var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"rule-link",attrs:{"to":_vm.url}},[_vm._v("\n    pravilo\n    "),_c('ArrowRight'),_c('span',{staticClass:"number"},[_vm._v(_vm._s(_vm.number)+".")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }